<template>
  <div 
    :class="filterPosition"
    class="listing-sort-widget"
  >
    <span v-if="showProductCount !== false" role="status" class="number-of-found-products">
      {{ productCount }} {{ productCountText }}
    </span>
    
    <div v-if="sortOptions" class="sort-wrapper" data-sort-menu>
      <button 
        @click="toggleSortDropdown" 
        :class="{ open : showSortDropdown }"
      >
        <span>
          <span>{{ sortByText }} </span>
          {{ sortByValue }}
        </span>
        <ChevronDownIcon />
      </button>

      <div 
        v-show="showSortDropdown"
        class="sort-dropdown"
      >
        <div
     
          v-for="(option, idx) in filteredSortOptions"
          class="input-wrapper"
        >
          <button
            :class="{'selected-option': option == selectedSortOrder}"
            @click="handleSelectSortOrder(option)"
          >
            {{ option.label }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useListingSortWidget } from '@/composables/listing-sort-widget.js';
import { computed } from 'vue';

const props = defineProps({
  sortOrder: String,
  sortBy: String,
  sortOptionsTwig: Object,
  sortOptionsTweakwise: Array,
  showProductCount: {
    type: Boolean,
    required: false
  },
  productCount: {
    type: Number,
    required: true
  },
  filterPosition: {
    type: String,
    required: false
  },
  marketId: {
    type: Number,
    required: true
  }
});
const { marketId } = props;

const {
  productCount,
  productCountText,
  sortOptions,
  toggleSortDropdown,
  showSortDropdown,
  sortByText,
  sortByValue,
  selectedSortOrder
  
} = useListingSortWidget(props);

const filteredSortOptions = computed(() => {
  if (!sortOptions.value) return [];

  return sortOptions.value.filter(option => {
    const optionRaw = JSON.parse(JSON.stringify(option));
    const isPrice = optionRaw.name === 'Price';
    const isMarket1 = marketId === 1;
    const include = !isPrice || (isPrice && isMarket1);
    return include;
  });
});


const handleSelectSortOrder = (option) => {
  selectedSortOrder.value = option;
};
</script>